import { SERVICE_BASE_URL } from "../../../../config/properties";
import httpClient, { HttpClient } from "../../../../core/api/HttpClient";


export interface OfficeServerDetails {
  config_id: number;
  officeServer: string;
  serverStatus: boolean,
  createdBy: string;
  lastModifiedBy: string;
  createdOn: string;
  lastModifiedOn: string;
}



interface GetAllOfficeServersResponse {
  code: string;
  description: string;
  data: OfficeServerDetails[];
}

export interface CreateOfficeServerResponse {
  code: string;
  description: string;
  data: OfficeServerDetails;
}

export interface UpdateOfficeServerRequest {
  officeServer: string;
  serverStatus: boolean;
}

export interface ServerAuditTrail {
  auditId: number;
  officeServer: string;
  actionPerformed: string;
  requestInitiator: string;
  requestTime: string;
}

export interface GetServerAuditTrailRequest {
  page: number;
  pageSize: number;
  serverName: string;
}

export interface GetServerAuditTrailResponse {
  count: number;
  content: ServerAuditTrail[];
}

interface ConfigRepository {
  getAllOfficeServers: () => Promise<OfficeServerDetails[]>;
  createOfficeServer: (officeServer: string) => Promise<OfficeServerDetails>;
  updateOfficeServer: (request: UpdateOfficeServerRequest) => Promise<void>;
  getServerAuditTrail: (request: GetServerAuditTrailRequest) => Promise<GetServerAuditTrailResponse>;
}

class ConfigRepositoryImpl implements ConfigRepository {
  private httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  async getAllOfficeServers() {
    const response = await this.httpClient.get<GetAllOfficeServersResponse>(
      `${SERVICE_BASE_URL}/api/v1/config/get/all`
    );

    return response.data.data;
  }

  async createOfficeServer(officeServer: string) {
    const response = await this.httpClient.post<CreateOfficeServerResponse>(
      `${SERVICE_BASE_URL}/api/v1/config/create/`,
      { officeServer, serverStatus: false }
    );

    return response.data.data;
  }

  async updateOfficeServer(request: UpdateOfficeServerRequest) {
    await this.httpClient.put<void>(
      `${SERVICE_BASE_URL}/api/v1/config/update`,
      request
    );

    return;
  }

  async getServerAuditTrail(request: GetServerAuditTrailRequest) {
    const response = await this.httpClient.get<GetServerAuditTrailResponse>(
      `${SERVICE_BASE_URL}/api/v1/config/audits`,
      { params: request }
    );

    return response.data;
  }
}

const configRepository = new ConfigRepositoryImpl(httpClient);

export default configRepository;



